import { displayedText, headerColumns, isOnScreen } from './exportVisibility';

const tableNames = {
  'w37-overdue-summary-table': 'Overdue Summary',
  'w37-due-summary-table': 'Due Summary',
  'w37-hot-summary-table': 'Hot Summary',
  'w37-poses-summary-table': 'Pose Summary',
  'w37-transition-matrix': 'Symptom Progression Matrix',
};

const sectionTitle = element => {
  for (let node = element.parentElement; node; node = node.parentElement) {
    if (node.matches('section, [data-w37-export-view]')) {
      return displayedText(node.querySelector('h2, h3')) || 'Pose Details';
    }
  }
  return 'Pose Details';
};

export const captureVisibleW37 = ({ root, view, sourceDraw, sourceDate, stale = false }) => {
  const pane = root?.querySelector(`[data-w37-export-view="${view}"][data-state="active"]`);
  const sections = new Map();
  const header = root?.querySelector('[data-testid="w37-page-header"]');
  const top = Math.max(0, header?.getBoundingClientRect().bottom || 0);
  const addRows = (name, columns, rows) => {
    if (!rows.length) return;
    const key = JSON.stringify([name, columns]);
    if (!sections.has(key)) sections.set(key, { name, columns, rows: [] });
    sections.get(key).rows.push(...rows);
  };

  pane?.querySelectorAll('table').forEach(table => {
    const columns = headerColumns(table);
    const event = table.closest('[data-w37-export-event]');
    const context = event ? displayedText(event.firstElementChild) : null;
    const rows = Array.from(table.tBodies).flatMap(body => Array.from(body.rows))
      .filter(row => !row.hasAttribute('data-w37-export-ignore') && isOnScreen(row, top))
      // Repeated column headings are represented by the workbook's header instead.
      .filter(row => !Array.from(row.cells).every(cell => cell.tagName === 'TH'))
      .map(row => {
        const cells = Array.from(row.cells).flatMap(cell =>
          [displayedText(cell), ...Array(Math.max(0, cell.colSpan - 1)).fill('')]);
        return context === null ? cells : [context, ...cells];
      });
    const name = table.dataset.w37ExportName || tableNames[table.dataset.testid] || sectionTitle(table);
    addRows(name, context === null ? columns : ['Event', ...columns], rows);
  });

  pane?.querySelectorAll('[data-w37-export-stat]').forEach(stat => {
    const value = stat.querySelector('[data-w37-export-value]');
    if (isOnScreen(value, top)) {
      addRows(`${sectionTitle(stat)} — Vitals`, ['Metric', 'Value'],
        [[stat.dataset.w37ExportStat, displayedText(value)]]);
    }
  });
  pane?.querySelectorAll('[data-w37-export-card-row]').forEach(row => {
    if (isOnScreen(row, top)) {
      addRows(row.dataset.w37ExportCardRow, ['Context', 'Displayed values'],
        [[row.dataset.w37ExportContext || '', displayedText(row)]]);
    }
  });
  return {
    view, sourceDraw, sourceDate, stale,
    capturedAt: new Date().toISOString(),
    sections: Array.from(sections.values()),
  };
};
